/** 회원 조회 keyword: 숫자만, 최대 자릿수 */
export const MEMBER_KEYWORD_MAX_LENGTH = 16

const SIGNUP_PHONE_PATTERN = /^010\d{7,8}$/

/**
 * 회원 조회 입력값 형식 (숫자만, 1~16자)
 */
export function isMemberSearchKeyword(keyword: string): boolean {
  const trimmed = keyword.trim()
  return /^\d{1,16}$/.test(trimmed)
}

/**
 * 간편가입 후보 전화번호 형태 (010 + 7~8자리 → 총 10~11자리)
 * 바코드 등 다른 숫자열은 false
 */
export function isSignupPhoneKeyword(keyword: string): boolean {
  const trimmed = keyword.trim()
  if (!isMemberSearchKeyword(trimmed)) return false
  return SIGNUP_PHONE_PATTERN.test(trimmed)
}
